function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
import { pausingUploadReason } from "./MultipartUploader.js";
import { throwIfAborted } from "./utils.js";
function removeMetadataFromURL(urlString) {
  var urlObject = new URL(urlString);
  urlObject.search = '';
  urlObject.hash = '';
  return urlObject.href;
}
var _abortMultipartUpload = /*#__PURE__*/_classPrivateFieldLooseKey("abortMultipartUpload");
var _cache = /*#__PURE__*/_classPrivateFieldLooseKey("cache");
var _createMultipartUpload = /*#__PURE__*/_classPrivateFieldLooseKey("createMultipartUpload");
var _fetchSignature = /*#__PURE__*/_classPrivateFieldLooseKey("fetchSignature");
var _getUploadParameters = /*#__PURE__*/_classPrivateFieldLooseKey("getUploadParameters");
var _listParts = /*#__PURE__*/_classPrivateFieldLooseKey("listParts");
var _previousRetryDelay = /*#__PURE__*/_classPrivateFieldLooseKey("previousRetryDelay");
var _requests = /*#__PURE__*/_classPrivateFieldLooseKey("requests");
var _retryDelays = /*#__PURE__*/_classPrivateFieldLooseKey("retryDelays");
var _sendCompletionRequest = /*#__PURE__*/_classPrivateFieldLooseKey("sendCompletionRequest");
var _setS3MultipartState = /*#__PURE__*/_classPrivateFieldLooseKey("setS3MultipartState");
var _uploadPartBytes = /*#__PURE__*/_classPrivateFieldLooseKey("uploadPartBytes");
var _getFile = /*#__PURE__*/_classPrivateFieldLooseKey("getFile");
var _shouldRetry = /*#__PURE__*/_classPrivateFieldLooseKey("shouldRetry");
var _nonMultipartUpload = /*#__PURE__*/_classPrivateFieldLooseKey("nonMultipartUpload");
export var HTTPCommunicationQueue = /*#__PURE__*/function () {
  function HTTPCommunicationQueue(_requests2, options, setS3MultipartState, getFile) {
    _classCallCheck(this, HTTPCommunicationQueue);
    Object.defineProperty(this, _nonMultipartUpload, {
      value: _nonMultipartUpload2
    });
    Object.defineProperty(this, _shouldRetry, {
      value: _shouldRetry2
    });
    Object.defineProperty(this, _abortMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cache, {
      writable: true,
      value: new WeakMap()
    });
    Object.defineProperty(this, _createMultipartUpload, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _fetchSignature, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getUploadParameters, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _listParts, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _previousRetryDelay, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _requests, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _retryDelays, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _sendCompletionRequest, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setS3MultipartState, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _uploadPartBytes, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getFile, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _requests)[_requests] = _requests2;
    _classPrivateFieldLooseBase(this, _setS3MultipartState)[_setS3MultipartState] = setS3MultipartState;
    _classPrivateFieldLooseBase(this, _getFile)[_getFile] = getFile;
    this.setOptions(options);
  }
  _createClass(HTTPCommunicationQueue, [{
    key: "setOptions",
    value: function setOptions(options) {
      var requests = _classPrivateFieldLooseBase(this, _requests)[_requests];
      if ('abortMultipartUpload' in options) {
        _classPrivateFieldLooseBase(this, _abortMultipartUpload)[_abortMultipartUpload] = requests.wrapPromiseFunction(options.abortMultipartUpload, {
          priority: 1
        });
      }
      if ('createMultipartUpload' in options) {
        _classPrivateFieldLooseBase(this, _createMultipartUpload)[_createMultipartUpload] = requests.wrapPromiseFunction(options.createMultipartUpload, {
          priority: -1
        });
      }
      if ('signPart' in options) {
        _classPrivateFieldLooseBase(this, _fetchSignature)[_fetchSignature] = requests.wrapPromiseFunction(options.signPart);
      }
      if ('listParts' in options) {
        _classPrivateFieldLooseBase(this, _listParts)[_listParts] = requests.wrapPromiseFunction(options.listParts);
      }
      if ('completeMultipartUpload' in options) {
        _classPrivateFieldLooseBase(this, _sendCompletionRequest)[_sendCompletionRequest] = requests.wrapPromiseFunction(options.completeMultipartUpload, {
          priority: 1
        });
      }
      if ('retryDelays' in options) {
        var _options$retryDelays;
        _classPrivateFieldLooseBase(this, _retryDelays)[_retryDelays] = (_options$retryDelays = options.retryDelays) != null ? _options$retryDelays : [];
      }
      if ('uploadPartBytes' in options) {
        _classPrivateFieldLooseBase(this, _uploadPartBytes)[_uploadPartBytes] = requests.wrapPromiseFunction(options.uploadPartBytes, {
          priority: Infinity
        });
      }
      if ('getUploadParameters' in options) {
        _classPrivateFieldLooseBase(this, _getUploadParameters)[_getUploadParameters] = requests.wrapPromiseFunction(options.getUploadParameters);
      }
    }
  }, {
    key: "getUploadId",
    value: function () {
      var _getUploadId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file, signal) {
        var _this = this;
        var cachedResult, promise, abortPromise;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!((cachedResult = _classPrivateFieldLooseBase(this, _cache)[_cache].get(file.data)) != null)) {
                _context2.next = 11;
                break;
              }
              _context2.prev = 1;
              _context2.next = 4;
              return cachedResult;
            case 4:
              return _context2.abrupt("return", _context2.sent);
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
            case 9:
              _context2.next = 0;
              break;
            case 11:
              promise = _classPrivateFieldLooseBase(this, _createMultipartUpload)[_createMultipartUpload](_classPrivateFieldLooseBase(this, _getFile)[_getFile](file), signal);
              abortPromise = function abortPromise() {
                promise.abort(signal.reason);
                _classPrivateFieldLooseBase(_this, _cache)[_cache].delete(file.data);
              };
              signal.addEventListener('abort', abortPromise, {
                once: true
              });
              _classPrivateFieldLooseBase(this, _cache)[_cache].set(file.data, promise);
              promise.then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(result) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        signal.removeEventListener('abort', abortPromise);
                        _classPrivateFieldLooseBase(_this, _setS3MultipartState)[_setS3MultipartState](file, result);
                        _classPrivateFieldLooseBase(_this, _cache)[_cache].set(file.data, result);
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }(), function () {
                signal.removeEventListener('abort', abortPromise);
                _classPrivateFieldLooseBase(_this, _cache)[_cache].delete(file.data);
              });
              return _context2.abrupt("return", promise);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 7]]);
      }));
      function getUploadId(_x, _x2) {
        return _getUploadId.apply(this, arguments);
      }
      return getUploadId;
    }()
  }, {
    key: "abortFileUpload",
    value: function () {
      var _abortFileUpload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
        var result, awaitedResult;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              result = _classPrivateFieldLooseBase(this, _cache)[_cache].get(file.data);
              if (!(result == null)) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              // Remove the cache entry right away for follow-up requests do not try to
              // use the soon-to-be aborted cached values.
              _classPrivateFieldLooseBase(this, _cache)[_cache].delete(file.data);
              _classPrivateFieldLooseBase(this, _setS3MultipartState)[_setS3MultipartState](file, Object.create(null));
              _context3.prev = 5;
              _context3.next = 8;
              return result;
            case 8:
              awaitedResult = _context3.sent;
              _context3.next = 14;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](5);
              return _context3.abrupt("return");
            case 14:
              _context3.next = 16;
              return _classPrivateFieldLooseBase(this, _abortMultipartUpload)[_abortMultipartUpload](_classPrivateFieldLooseBase(this, _getFile)[_getFile](file), awaitedResult);
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[5, 11]]);
      }));
      function abortFileUpload(_x4) {
        return _abortFileUpload.apply(this, arguments);
      }
      return abortFileUpload;
    }()
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file, chunks, signal) {
        var _this2 = this;
        var _yield$this$getUpload, uploadId, key, parts;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              throwIfAborted(signal);
              if (!(chunks.length === 1 && !chunks[0].shouldUseMultipart)) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", _classPrivateFieldLooseBase(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks[0], signal));
            case 3:
              _context4.next = 5;
              return this.getUploadId(file, signal);
            case 5:
              _yield$this$getUpload = _context4.sent;
              uploadId = _yield$this$getUpload.uploadId;
              key = _yield$this$getUpload.key;
              throwIfAborted(signal);
              _context4.prev = 9;
              _context4.next = 12;
              return Promise.all(chunks.map(function (chunk, i) {
                return _this2.uploadChunk(file, i + 1, chunk, signal);
              }));
            case 12:
              parts = _context4.sent;
              throwIfAborted(signal);
              _context4.next = 16;
              return _classPrivateFieldLooseBase(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase(this, _getFile)[_getFile](file), {
                key: key,
                uploadId: uploadId,
                parts: parts,
                signal: signal
              }, signal).abortOn(signal);
            case 16:
              return _context4.abrupt("return", _context4.sent);
            case 19:
              _context4.prev = 19;
              _context4.t0 = _context4["catch"](9);
              if ((_context4.t0 == null ? void 0 : _context4.t0.cause) !== pausingUploadReason && (_context4.t0 == null ? void 0 : _context4.t0.name) !== 'AbortError') {
                // We purposefully don't wait for the promise and ignore its status,
                // because we want the error `err` to bubble up ASAP to report it to the
                // user. A failure to abort is not that big of a deal anyway.
                this.abortFileUpload(file);
              }
              throw _context4.t0;
            case 23:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[9, 19]]);
      }));
      function uploadFile(_x5, _x6, _x7) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }()
  }, {
    key: "restoreUploadFile",
    value: function restoreUploadFile(file, uploadIdAndKey) {
      _classPrivateFieldLooseBase(this, _cache)[_cache].set(file.data, uploadIdAndKey);
    }
  }, {
    key: "resumeUploadFile",
    value: function () {
      var _resumeUploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(file, chunks, signal) {
        var _this3 = this;
        var _yield$this$getUpload2, uploadId, key, alreadyUploadedParts, parts;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              throwIfAborted(signal);
              if (!(chunks.length === 1 && chunks[0] != null && !chunks[0].shouldUseMultipart)) {
                _context5.next = 3;
                break;
              }
              return _context5.abrupt("return", _classPrivateFieldLooseBase(this, _nonMultipartUpload)[_nonMultipartUpload](file, chunks[0], signal));
            case 3:
              _context5.next = 5;
              return this.getUploadId(file, signal);
            case 5:
              _yield$this$getUpload2 = _context5.sent;
              uploadId = _yield$this$getUpload2.uploadId;
              key = _yield$this$getUpload2.key;
              throwIfAborted(signal);
              _context5.next = 11;
              return _classPrivateFieldLooseBase(this, _listParts)[_listParts](_classPrivateFieldLooseBase(this, _getFile)[_getFile](file), {
                uploadId: uploadId,
                key: key,
                signal: signal
              }, signal).abortOn(signal);
            case 11:
              alreadyUploadedParts = _context5.sent;
              throwIfAborted(signal);
              _context5.next = 15;
              return Promise.all(chunks.map(function (chunk, i) {
                var partNumber = i + 1;
                var alreadyUploadedInfo = alreadyUploadedParts.find(function (_ref) {
                  var PartNumber = _ref.PartNumber;
                  return PartNumber === partNumber;
                });
                if (alreadyUploadedInfo == null) {
                  return _this3.uploadChunk(file, partNumber, chunk, signal);
                }
                // Already uploaded chunks are set to null. If we are restoring the upload, we need to mark it as already uploaded.
                chunk == null || chunk.setAsUploaded == null || chunk.setAsUploaded();
                return {
                  PartNumber: partNumber,
                  ETag: alreadyUploadedInfo.ETag
                };
              }));
            case 15:
              parts = _context5.sent;
              throwIfAborted(signal);
              return _context5.abrupt("return", _classPrivateFieldLooseBase(this, _sendCompletionRequest)[_sendCompletionRequest](_classPrivateFieldLooseBase(this, _getFile)[_getFile](file), {
                key: key,
                uploadId: uploadId,
                parts: parts,
                signal: signal
              }, signal).abortOn(signal));
            case 18:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function resumeUploadFile(_x8, _x9, _x10) {
        return _resumeUploadFile.apply(this, arguments);
      }
      return resumeUploadFile;
    }()
  }, {
    key: "uploadChunk",
    value: function () {
      var _uploadChunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(file, partNumber, chunk, signal) {
        var _this4 = this;
        var _yield$this$getUpload3, uploadId, key, signatureRetryIterator, chunkRetryIterator, shouldRetrySignature, _loop, _ret;
        return _regeneratorRuntime().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              throwIfAborted(signal);
              _context7.next = 3;
              return this.getUploadId(file, signal);
            case 3:
              _yield$this$getUpload3 = _context7.sent;
              uploadId = _yield$this$getUpload3.uploadId;
              key = _yield$this$getUpload3.key;
              signatureRetryIterator = _classPrivateFieldLooseBase(this, _retryDelays)[_retryDelays].values();
              chunkRetryIterator = _classPrivateFieldLooseBase(this, _retryDelays)[_retryDelays].values();
              shouldRetrySignature = function shouldRetrySignature() {
                var next = signatureRetryIterator.next();
                if (next == null || next.done) {
                  return null;
                }
                return next.value;
              };
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var chunkData, onProgress, onComplete, signature, timeout;
                return _regeneratorRuntime().wrap(function _loop$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      throwIfAborted(signal);
                      chunkData = chunk.getData();
                      onProgress = chunk.onProgress, onComplete = chunk.onComplete;
                      _context6.prev = 3;
                      _context6.next = 6;
                      return _classPrivateFieldLooseBase(_this4, _fetchSignature)[_fetchSignature](_classPrivateFieldLooseBase(_this4, _getFile)[_getFile](file), {
                        uploadId: uploadId,
                        key: key,
                        partNumber: partNumber,
                        body: chunkData,
                        signal: signal
                      }).abortOn(signal);
                    case 6:
                      signature = _context6.sent;
                      _context6.next = 17;
                      break;
                    case 9:
                      _context6.prev = 9;
                      _context6.t0 = _context6["catch"](3);
                      timeout = shouldRetrySignature();
                      if (!(timeout == null || signal.aborted)) {
                        _context6.next = 14;
                        break;
                      }
                      throw _context6.t0;
                    case 14:
                      _context6.next = 16;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, timeout);
                      });
                    case 16:
                      return _context6.abrupt("return", 0);
                    case 17:
                      throwIfAborted(signal);
                      _context6.prev = 18;
                      _context6.t1 = _objectSpread;
                      _context6.t2 = {
                        PartNumber: partNumber
                      };
                      _context6.next = 23;
                      return _classPrivateFieldLooseBase(_this4, _uploadPartBytes)[_uploadPartBytes]({
                        signature: signature,
                        body: chunkData,
                        size: chunkData.size,
                        onProgress: onProgress,
                        onComplete: onComplete,
                        signal: signal
                      }).abortOn(signal);
                    case 23:
                      _context6.t3 = _context6.sent;
                      _context6.t4 = (0, _context6.t1)(_context6.t2, _context6.t3);
                      return _context6.abrupt("return", {
                        v: _context6.t4
                      });
                    case 28:
                      _context6.prev = 28;
                      _context6.t5 = _context6["catch"](18);
                      _context6.next = 32;
                      return _classPrivateFieldLooseBase(_this4, _shouldRetry)[_shouldRetry](_context6.t5, chunkRetryIterator);
                    case 32:
                      if (_context6.sent) {
                        _context6.next = 34;
                        break;
                      }
                      throw _context6.t5;
                    case 34:
                    case "end":
                      return _context6.stop();
                  }
                }, _loop, null, [[3, 9], [18, 28]]);
              });
            case 10:
              return _context7.delegateYield(_loop(), "t0", 11);
            case 11:
              _ret = _context7.t0;
              if (!(_ret === 0)) {
                _context7.next = 14;
                break;
              }
              return _context7.abrupt("continue", 16);
            case 14:
              if (!_ret) {
                _context7.next = 16;
                break;
              }
              return _context7.abrupt("return", _ret.v);
            case 16:
              _context7.next = 10;
              break;
            case 18:
            case "end":
              return _context7.stop();
          }
        }, _callee6, this);
      }));
      function uploadChunk(_x11, _x12, _x13, _x14) {
        return _uploadChunk.apply(this, arguments);
      }
      return uploadChunk;
    }()
  }]);
  return HTTPCommunicationQueue;
}();
function _shouldRetry2(_x15, _x16) {
  return _shouldRetry3.apply(this, arguments);
}
function _shouldRetry3() {
  _shouldRetry3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(err, retryDelayIterator) {
    var _this5 = this;
    var _err$source, requests, status, next, _next2, _next3;
    return _regeneratorRuntime().wrap(function _callee7$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          requests = _classPrivateFieldLooseBase(this, _requests)[_requests];
          status = err == null || (_err$source = err.source) == null ? void 0 : _err$source.status; // TODO: this retry logic is taken out of Tus. We should have a centralized place for retrying,
          // perhaps the rate limited queue, and dedupe all plugins with that.
          if (!(status == null)) {
            _context8.next = 4;
            break;
          }
          return _context8.abrupt("return", false);
        case 4:
          if (!(status === 403 && err.message === 'Request has expired')) {
            _context8.next = 16;
            break;
          }
          if (requests.isPaused) {
            _context8.next = 14;
            break;
          }
          if (!(requests.limit === 1 || _classPrivateFieldLooseBase(this, _previousRetryDelay)[_previousRetryDelay] == null)) {
            _context8.next = 11;
            break;
          }
          next = retryDelayIterator.next();
          if (!(next == null || next.done)) {
            _context8.next = 10;
            break;
          }
          return _context8.abrupt("return", false);
        case 10:
          // If there are more than 1 request done in parallel, the RLQ limit is
          // decreased and the failed request is requeued after waiting for a bit.
          // If there is only one request in parallel, the limit can't be
          // decreased, so we iterate over `retryDelayIterator` as we do for
          // other failures.
          // `#previousRetryDelay` caches the value so we can re-use it next time.
          _classPrivateFieldLooseBase(this, _previousRetryDelay)[_previousRetryDelay] = next.value;
        case 11:
          // No need to stop the other requests, we just want to lower the limit.
          requests.rateLimit(0);
          _context8.next = 14;
          return new Promise(function (resolve) {
            return setTimeout(resolve, _classPrivateFieldLooseBase(_this5, _previousRetryDelay)[_previousRetryDelay]);
          });
        case 14:
          _context8.next = 37;
          break;
        case 16:
          if (!(status === 429)) {
            _context8.next = 24;
            break;
          }
          if (requests.isPaused) {
            _context8.next = 22;
            break;
          }
          _next2 = retryDelayIterator.next();
          if (!(_next2 == null || _next2.done)) {
            _context8.next = 21;
            break;
          }
          return _context8.abrupt("return", false);
        case 21:
          requests.rateLimit(_next2.value);
        case 22:
          _context8.next = 37;
          break;
        case 24:
          if (!(status > 400 && status < 500 && status !== 409)) {
            _context8.next = 28;
            break;
          }
          return _context8.abrupt("return", false);
        case 28:
          if (!(typeof navigator !== 'undefined' && navigator.onLine === false)) {
            _context8.next = 32;
            break;
          }
          // The navigator is offline, let's wait for it to come back online.
          if (!requests.isPaused) {
            requests.pause();
            window.addEventListener('online', function () {
              requests.resume();
            }, {
              once: true
            });
          }
          _context8.next = 37;
          break;
        case 32:
          // Other error code means the request can be retried later.
          _next3 = retryDelayIterator.next();
          if (!(_next3 == null || _next3.done)) {
            _context8.next = 35;
            break;
          }
          return _context8.abrupt("return", false);
        case 35:
          _context8.next = 37;
          return new Promise(function (resolve) {
            return setTimeout(resolve, _next3.value);
          });
        case 37:
          return _context8.abrupt("return", true);
        case 38:
        case "end":
          return _context8.stop();
      }
    }, _callee7, this);
  }));
  return _shouldRetry3.apply(this, arguments);
}
function _nonMultipartUpload2(_x17, _x18, _x19) {
  return _nonMultipartUpload3.apply(this, arguments);
}
function _nonMultipartUpload3() {
  _nonMultipartUpload3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(file, chunk, signal) {
    var _yield$_classPrivateF, _yield$_classPrivateF2, method, url, fields, headers, body, data, formData, onProgress, onComplete, result;
    return _regeneratorRuntime().wrap(function _callee8$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return _classPrivateFieldLooseBase(this, _getUploadParameters)[_getUploadParameters](_classPrivateFieldLooseBase(this, _getFile)[_getFile](file), {
            signal: signal
          }).abortOn(signal);
        case 2:
          _yield$_classPrivateF = _context9.sent;
          _yield$_classPrivateF2 = _yield$_classPrivateF.method;
          method = _yield$_classPrivateF2 === void 0 ? 'POST' : _yield$_classPrivateF2;
          url = _yield$_classPrivateF.url;
          fields = _yield$_classPrivateF.fields;
          headers = _yield$_classPrivateF.headers;
          data = chunk.getData();
          if (method.toUpperCase() === 'POST') {
            formData = new FormData();
            Object.entries(fields).forEach(function (_ref2) {
              var _ref4 = _slicedToArray(_ref2, 2),
                key = _ref4[0],
                value = _ref4[1];
              return formData.set(key, value);
            });
            formData.set('file', data);
            body = formData;
          } else {
            body = data;
          }
          onProgress = chunk.onProgress, onComplete = chunk.onComplete;
          _context9.next = 13;
          return _classPrivateFieldLooseBase(this, _uploadPartBytes)[_uploadPartBytes]({
            signature: {
              url: url,
              headers: headers,
              method: method
            },
            body: body,
            size: data.size,
            onProgress: onProgress,
            onComplete: onComplete,
            signal: signal
          }).abortOn(signal);
        case 13:
          result = _context9.sent;
          return _context9.abrupt("return", 'location' in result ? result : _objectSpread({
            location: removeMetadataFromURL(url)
          }, result));
        case 15:
        case "end":
          return _context9.stop();
      }
    }, _callee8, this);
  }));
  return _nonMultipartUpload3.apply(this, arguments);
}